<div class="draft-modal">
  <div class="draft-modal-recipients-block">
    <div class="draft-modal-recipients">
      <span class="draft-modal-recipients-label">{{ _w.emailToLabel() }}</span>
      <div class="draft-modal-recipients-field">
        @for (email of _to(); track email) {
          <myre-tag
            [text]="_chipText(email)"
            [isDeletable]="true"
            (onDelete)="_removeRecipient('to', email)"
          />
        }
        @if (_addable().length) {
          <select
            #toSelect
            class="draft-modal-recipients-add"
            (change)="_addRecipient('to', toSelect.value); toSelect.value = ''"
          >
            <option value="">{{ _w.addRecipient() }}</option>
            @for (email of _addable(); track email) {
              <option [value]="email">{{ email }}</option>
            }
          </select>
        }
      </div>
    </div>

    <div class="draft-modal-recipients">
      <span class="draft-modal-recipients-label">{{ _w.emailCcLabel() }}</span>
      <div class="draft-modal-recipients-field">
        @for (email of _cc(); track email) {
          <myre-tag
            [text]="_chipText(email)"
            [isDeletable]="true"
            (onDelete)="_removeRecipient('cc', email)"
          />
        }
        @if (_addable().length) {
          <select
            #ccSelect
            class="draft-modal-recipients-add"
            (change)="_addRecipient('cc', ccSelect.value); ccSelect.value = ''"
          >
            <option value="">{{ _w.addRecipient() }}</option>
            @for (email of _addable(); track email) {
              <option [value]="email">{{ email }}</option>
            }
          </select>
        }
      </div>
    </div>

    <div class="draft-modal-recipients">
      <span class="draft-modal-recipients-label">{{ _w.emailBccLabel() }}</span>
      <span class="draft-modal-bcc">{{ _bcc() }} {{ _w.emailBccYou() }}</span>
    </div>

    @if (_recipientsPrivate()) {
      <p class="draft-modal-private-note">
        <i class="myre-icon-eye-off"></i>
        {{ _w.recipientsPrivateNote() }}
      </p>
    }

    @if (_attachments().length || _addableAttachments().length) {
      <div class="draft-modal-recipients">
        <span class="draft-modal-recipients-label">{{
          _w.attachmentsLabel()
        }}</span>
        <div class="draft-modal-recipients-field">
          @for (doc of _attachments(); track doc.key) {
            <myre-tag
              [text]="_chipText(doc.name)"
              [isDeletable]="true"
              (onDelete)="_removeAttachment(doc.key)"
            />
          }
          @if (_addableAttachments().length) {
            <select
              #attachSelect
              class="draft-modal-recipients-add"
              (change)="
                _addAttachment(attachSelect.value); attachSelect.value = ''
              "
            >
              <option value="">{{ _w.addRecipient() }}</option>
              @for (doc of _addableAttachments(); track doc.key) {
                <option [value]="doc.key">{{ doc.name }}</option>
              }
            </select>
          }
        </div>
      </div>
    }
  </div>

  <label class="draft-modal-field-label" for="draft-subject">{{
    _w.emailSubjectLabel()
  }}</label>
  <myre-textbox
    id="draft-subject"
    [type]="'text'"
    [required]="false"
    [ngModel]="_subject()"
    (ngModelChange)="_subject.set($event)"
  />

  <myre-wysiwyg
    [height]="220"
    [ngModel]="_editorHtml()"
    (ngModelChange)="_onEditorChange($event)"
    (selectedTextChanged)="_onSelectedText($event)"
  />

  @if (_selectedText()) {
    <div class="draft-modal-selection-chip">
      <i class="myre-icon-cursor"></i>
      <span>{{ _w.selectedTextLabel() }} {{ _selectedText() }}</span>
      <button
        class="draft-modal-selection-clear"
        type="button"
        [title]="_w.clearSelection()"
        (click)="_clearSelection()"
      >
        <i class="myre-icon-close"></i>
      </button>
    </div>
  }

  <div class="draft-modal-refine">
    <myre-textbox
      class="draft-modal-refine-input"
      [type]="'text'"
      [required]="false"
      [placeholder]="_w.aiRefinePlaceholder()"
      [disabled]="_loading()"
      [ngModel]="_instruction()"
      (ngModelChange)="_instruction.set($event)"
    />
    <myre-button
      [label]="_w.aiRefine()"
      [icon]="'myre-icon-magic'"
      [theme]="ButtonTheme.Secondary"
      [disabled]="_loading() || !_instruction().trim()"
      [isLoading]="_loading()"
      (onClick)="_onRefine()"
    />
  </div>

  <div class="draft-modal-footer">
    <myre-button
      [label]="_w.cancel()"
      [theme]="ButtonTheme.Secondary"
      (onClick)="_onClose()"
    />
    <myre-button
      [label]="_w.validateDraftChanges()"
      [theme]="ButtonTheme.Primary"
      (onClick)="_onConfirm()"
    />
  </div>
</div>
